import styled from "@emotion/styled";
import { Paper } from "@mui/material";

import { PageHeader } from "@/components";
import { useCustomTranslation } from "@/utils/useCustomTranslation";

import { CourseInfo, EnterClassButton } from ".";

import { ScheduleResponseDto } from "@shared/generated/api/model";

interface WaitingRoomHeaderProps {
  schedule: ScheduleResponseDto;
}

export const WaitingRoomHeader = ({ schedule }: WaitingRoomHeaderProps) => {
  const { t } = useCustomTranslation();
  return (
    <>
      <PageHeader
        title={t("class_waiting_room")}
        backButtonEnabled
        path="/my/schedule"
      />
      <ContentWrapper>
        <CourseInfo schedule={schedule} />
        <EnterClassButton schedule={schedule} />
      </ContentWrapper>
    </>
  );
};

const ContentWrapper = styled(Paper)`
  padding: 16px;
  box-shadow: none;
  border: 1px solid #d2d2d2;
  border-radius: 8px;
  justify-content: space-between;
  display: flex;
  gap: 16px;
  ${({ theme }) => theme.media.tabletSm} {
    flex-direction: column;
  }
`;
